import React, { Component, PropTypes } from 'react'
import styles from './StatusMessages.css'
import CSSModules from 'react-css-modules'
import connectToStores from 'alt-utils/lib/connectToStores'
import MessageStore from '../../stores/MessageStore'

@connectToStores
@CSSModules(styles, { allowMultiple: true })
export default class StatusMessages extends Component {
  static propTypes = {
    messages: PropTypes.arrayOf(PropTypes.object)
  }
  static defaultProps = {
    messages: []
  }
  static getStores () {
    return [MessageStore]
  }
  static getPropsFromStores () {
    return MessageStore.getState()
  }  

  render () {
    if (this.props.messages.length == 0) return ''
    return (
      <div styleName="status-messages">
      {this.props.messages
        .map((message, i) =>
          <p key={`message_${i}`} styleName="message">{message.messages.sv}</p>)}
      </div>            
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/StatusMessages/StatusMessages.js